import { useCallback } from "react";
import RankingTable from "../components/RankingTable";
import { useAuth } from "../auth/AuthProvider";
import { getBrandsRanking, getModelsRanking } from "../api";

function ControlsRankingPage() {
    const { withAuth } = useAuth();

    const fetchBrands = useCallback((options) => {
        return withAuth((token) => getBrandsRanking(token, options));
    }, [withAuth]);

    const fetchModels = useCallback((options) => {
        return withAuth((token) => getModelsRanking(token, options));
    }, [withAuth]);

    return (
        <section>
            <div className="mb-3">
                <h1 className="h4 mb-1">Classements contrôles</h1>
                <p className="text-secondary mb-0">Top marques et modèles les plus contrôlés.</p>
            </div>

            <div className="row g-3">
                <div className="col-12 col-xl-6">
                    <RankingTable
                        title="Classement des marques"
                        columns={[
                            { key: "brand", label: "Marque" }
                        ]}
                        fetchRanking={fetchBrands}
                    />
                </div>

                <div className="col-12 col-xl-6">
                    <RankingTable
                        title="Classement des modèles"
                        columns={[
                            { key: "brand", label: "Marque" },
                            { key: "model", label: "Modèle" }
                        ]}
                        fetchRanking={fetchModels}
                    />
                </div>
            </div>
        </section>
    );
}

export default ControlsRankingPage;
